var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoneyoffIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MoneyOffRounded"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.5 6.9C13.92 6.9 14.63 7.44 14.89 8.3C15.02 8.73 15.45 9 15.9 9H15.96C16.66 9 17.18 8.29 16.93 7.64C16.49 6.49 15.52 5.56 14 5.19V4.5C14 3.67 13.33 3 12.5 3C11.67 3 11 3.67 11 4.5V5.16C10.61 5.24 10.25 5.37 9.90004 5.52L11.41 7.03C11.73 6.95 12.1 6.9 12.5 6.9ZM4.77004 4.62C4.38004 5.01 4.38004 5.64 4.77004 6.03L7.50004 8.77C7.50004 10.85 9.06004 11.99 11.41 12.68L14.92 16.19C14.58 16.68 13.87 17.1 12.5 17.1C10.85 17.1 10 16.51 9.67004 15.67C9.52004 15.28 9.18004 15 8.77004 15H8.60004C7.88004 15 7.36004 15.74 7.65004 16.39C8.24004 17.72 9.54004 18.51 11.01 18.83V19.5C11.01 20.33 11.68 21 12.51 21C13.34 21 14.01 20.33 14.01 19.5V18.85C14.97 18.67 15.84 18.3 16.47 17.73L17.98 19.24C18.37 19.63 19 19.63 19.39 19.24C19.78 18.85 19.78 18.22 19.39 17.83L6.18004 4.62C5.79004 4.23 5.16004 4.23 4.77004 4.62Z",
    fill: "#121212"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyoffIcon);
export default __webpack_public_path__ + "static/media/moneyoff-icon.a232b2d830afff000811f42e959e31e1.svg";
export { ForwardRef as ReactComponent };